import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Admission from './pages/Admission';
import Facilities from './pages/Facilities';
import Gallery from './pages/Gallery';
import Departments from './pages/Departments';
import ComputerScience from './pages/ComputerScience';
import ElectronicsEngineering from './pages/ElectronicsEngineering';
import MechanicalEngineering from './pages/MechanicalEngineering';
import ApparelDesign from './pages/ApparelDesign';
import PrincipalsDesk from './pages/PrincipalsDesk';
import GoverningCouncil from './pages/GoverningCouncil';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import AntiRagging from './pages/AntiRagging';
import Grievance from './pages/Grievance';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admission" element={<Admission />} />
        <Route path="/facilities" element={<Facilities />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/departments" element={<Departments />} />
        <Route path="/computer-science" element={<ComputerScience />} />
        <Route path="/electronics-engineering" element={<ElectronicsEngineering />} />
        <Route path="/mechanical-engineering" element={<MechanicalEngineering />} />
        <Route path="/apparel-design" element={<ApparelDesign />} />
        <Route path="/principalsdesk" element={<PrincipalsDesk />} />
        <Route path="/governing-council" element={<GoverningCouncil />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/anti-ragging" element={<AntiRagging />} />
        <Route path="/grievance" element={<Grievance />} />
      </Routes>
    </Router>
  );
}

export default App;
